import Head from "next/head";

import pluginPlatforms from "@/data/connect-tools.json";
import PlatformMain from "@/components/info/platform-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";
import { GetStaticProps } from "next";
import { PluginPlatform } from "@/@types/PluginPlatform";
import { routes } from "@/utils/routes";

type Props = {
  platformDetails: PluginPlatform;
};

export default function Platform({ platformDetails }: Props) {
  return (
    <>
      <Head>
        <title>{seoData.INFO_CONNECT_TOOLS_PLUGIN.title}</title>
        <SeoMetaData
          data={{
            ...seoData.INFO_CONNECT_TOOLS_PLUGIN,
            canonicalUrl: `${seoData.CARRIER.canonicalUrl}${routes.connectTools}/${platformDetails?.slug}`,
          }}
        />
      </Head>

      <PlatformMain platformDetails={platformDetails} />
    </>
  );
}

export async function getStaticPaths() {
  // Generate the paths for each news item
  const paths = pluginPlatforms.map((platform) => ({
    params: { platform: `${platform.slug}` },
  }));

  return {
    paths,
    // output:"export" forbids fallback:true|blocking; full path set enumerated above.
    fallback: false,
  };
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  if (!params || !params.platform) {
    return { notFound: true };
  }

  const platformDetails = pluginPlatforms.find(
    ({ slug }) => slug === params.platform
  );

  if (!platformDetails) {
    return { notFound: true };
  }

  return {
    props: { platformDetails },
  };
};
